<template>
  <div class="select-industry">
    <span
      class="select-text"
      :class="{ placeholder: !industry }"
      @click="showPopup"
    >
      {{ industry || placeholder }}
      <i class="el-icon-arrow-down"></i>
    </span>
    <Popup
      ref="selectPopup"
      v-model="industry"
      :hot-data="hotData"
      hotTitle="热门行业"
      :data="dataIndustry"
      @input="industryChange"
    ></Popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Popup from "./searchPopupt";
import { dataIndustry } from "../utils/industry";
export default {
  name: "Industry",
  components: {
    Popup
  },
  props: {
    focus: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择行业"
    }
  },
  data() {
    return {
      industry: null,
      dataIndustry: dataIndustry,
      hotData: ["网络科技", "广告", "建筑装潢", "科技", "文化传媒", "教育科技"]
    };
  },
  methods: {
    ...mapActions(["getIndustry"]),
    industryChange(v) {
      // console.log(v, "00000-0000");
      this.industry = v;
      this.$store.commit("setIndustry", v);
    },
    showPopup() {
      this.$refs.selectPopup.show();
    }
  },
  created() {
    // this.getIndustry();
    // this.industry = this.$store.state.industry;
    // console.log(this.dataIndustry, "0000");
  },
  watch: {
    // "$store.state.industry": function(val) {
    //   this.industry = val;
    // }
    // industry: function(val) {
    //   this.industryChange(val);
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.select-industry {
  $height: 36px;
  font-size: 14px;
  line-height: $height;
  height: $height;
  .select-text {
    display: block;
    line-height: $height;
    padding: 0 15px;
    position: relative;
    &.placeholder {
      color: #ccc;
      font-size: 13px;
    }
    i {
      font-size: 14px;
      color: #c0c4cc;
      position: absolute;
      right: 12px;
      height: 100%;
      line-height: $height;
    }
  }
}
</style>
